// Copyright (c) 2019 Jian Weihang <tonytonyjan@gmail.com> https://codepen.io/tonytonyjan/project/editor/XEkOkv

export async function copyExif(src, dest) {
  const exif = await retrieveExif(src);
  return new Blob([dest.slice(0, 2), exif, dest.slice(2)], {
    type: "image/jpeg"
  });
}

const SOS = 0xffda,
  APP1 = 0xffe1,
  EXIF = 0x45786966,
  retrieveExif = blob =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener("load", ({ target: { result: buffer } }) => {
        const view = new DataView(buffer);

        let offset = 0;

        if (view.getUint16(offset) !== 0xffd8)
          return reject("not a valid jpeg");
        offset += 2;
        const cond = true;
        while (cond) {
          const marker = view.getUint16(offset);

          if (marker === SOS) break;
          const size = view.getUint16(offset + 2);

          if (marker === APP1 && view.getUint32(offset + 4) === EXIF)
            return resolve(blob.slice(offset, offset + 2 + size));

          offset += 2 + size;
        }
        return resolve(new Blob());
      });
      reader.readAsArrayBuffer(blob);
    });
// fin tony copyExif.js

export const blobToImage = blob => {
  return new Promise(resolve => {
    const reader = new FileReader(),
      image = new Image();
    image.onload = () => resolve(image);
    reader.onload = ({ target: { result: dataURL } }) => (image.src = dataURL);
    reader.readAsDataURL(blob);
  });
};

export const blobTob64 = blob => {
  return new Promise(resolve => {
    // Define the FileReader which is able to read the contents of Blob
    const reader = new FileReader();

    // The magic always begins after the Blob is successfully loaded
    reader.onload = () => {
      // Since it contains the Data URI, we should remove the prefix and keep only Base64 string
      var b64 = reader.result.replace(/^data:.+;base64,/, "");
      //console.log(b64); //-> "V2VsY29tZSB0byA8Yj5iYXNlNjQuZ3VydTwvYj4h"

      // Decode the Base64 string and show result just to make sure that everything is OK
      //var html = atob(b64);
      resolve(b64);
      // console.log(html); //-> "Welcome to <b>base64.guru</b>!"
    };
    reader.readAsDataURL(blob);
  });
};

export function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || "";
  sliceSize = sliceSize || 512;

  let byteCharacters = atob(b64Data);
  let byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    let slice = byteCharacters.slice(offset, offset + sliceSize);

    let byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    let byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  let blob = new Blob(byteArrays, { type: contentType });
  return blob;
}
